import React from 'react';
import './App.css';
import InstagramPost from './components/InstagramPost';

function App() {
  return (
    <div className="App">
      <InstagramPost />
    </div>
  );
}

export default App;
